<template>
  <v-card class="d-flex flex-column align-center justify-center mx-md-4 my-md-4 elevation-0 py-16" outlined>
    <img :src="InputMarkImage" alt="student-setting" />
    <span class="mt-4">
      Vui lòng cung cấp các thông tin ở trên, sau đó ấn [Phân quyền] để thiết lập quyền
    </span>
  </v-card>
</template>

<script>
import MarkImage from '@/assets/mark-view-icon.svg'
import InputMarkImage from '@/assets/mark-input-icon.svg'

export default {
  components: {},
  props: {},
  data() {
    return {
      MarkImage,
      InputMarkImage
    }
  },
  computed: {}
}
</script>

<style></style>
